/*
 * File: /src/helpers/field-liquid-generate-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Wednesday, 25th July 2018 1:23:56 pm
 * Last Modified: Tue Oct 08 2019
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
import Store from '@/stores'

const generateSimple = ({ field, scope }) => {
    return `
{% assign ${field.key} = ${scope}.metafields.airf.${field.key} %}
{% if ${field.key} and ${field.key} != '&nbsp' %}
    {{ ${field.key} }}
{% endif %}
`
}

const generateImage = ({ field, scope }) => {
    return `
{% assign ${field.key} = ${scope}.metafields.airf.${field.key} %}
{% if ${field.key} and ${field.key} != '&nbsp' %}
    <img src="{{ ${field.key} }}" />
{% endif %}
`  
}

const generateBoolean = ({ field, scope }) => {
    return `
{% assign ${field.key} = ${scope}.metafields.airf.${field.key} %}
{% if ${field.key} == "true" %}
    true
{% else %}
    false
{% endif %}
`  
    }

const generateRepeaterChildCode = ({ field, child, scope }) => {
    let _key = child.key.replace('_[i]', '')
    let _inside = null
    switch(child.type) {
        case 'relation':
                _inside = generateRelation({ field: child, scope, schema: child.subForm, airfFieldKey: `${field.key}_child_key` })
            break
    }

    if (!_inside) {
        _inside = `<div class="${child.type}">{{ ${scope}.metafields.airf[${field.key}_child_key] }}</div>`
    }

    return `
        {% if ${field.key}_child_key contains "${_key}" %}
            ${_inside}
        {% endif %}
`  
}

const generateRepeater = ({ field, scope }) => {
    let childCodes = ``
    for (let child of field.children) {
        childCodes += generateRepeaterChildCode({field, child, scope})
    }

    return `
{% assign ${field.key} = ${scope}.metafields.airf.${field.key} %}
{% if ${field.key} and ${field.key} != blank %}
    {% assign separator = "###" %}
    {% assign ${field.key}_childs_keys = ${field.key} | split: separator %}
    {% for ${field.key}_child_key in ${field.key}_childs_keys %}
        ${childCodes}
    {% endfor %}
{% endif %}
`  
}

const generateRepeaterJson = ({ field, scope }) => {
    return `
{% assign scope = ${scope}.metafields.airf %}
{% assign ${field.key} = scope.${field.key} %}
{% if ${field.key} and ${field.key} != blank %}
    {% for row in ${field.key}.rows %}
        Row Data 
        {% for row_field in row %}
            {% comment %} Show ech field in row {% endcomment %}
            <div id="{{row_field.key}}">
                <span>{{row_field.label}}: {{ scope[row_field.key] }}</span>
            </div>

            {% comment %} Conditional show items, for example you can decide which html tag to use {% endcomment %}
            {% if row_field.key contains "XXX" %}
                <h2 id="{{row_field.key}}">{{ scope[row_field.key] }}</h2>
            {% endif %}
        {% endfor %}
    {% endfor %}
{% endif %}
`  
}

const generateRelationVariant = ({ field, scope, airfFieldKey }) => {
    airfFieldKey = airfFieldKey || `'${field.key}'`
    return `
{% assign ${field.key} = ${scope}.metafields.airf[${airfFieldKey}] %}
{% if ${field.key} and ${field.key} != blank %}
    {% assign data_separator = "/r###r/" %}
    {% assign separator = "###" %}
    {% assign related_data = ${field.key} | split: data_separator %}
    {% assign data_product = related_data[0] | split: separator %}
    {% assign product_handle = data_product[1] %}
    {% assign related_product = all_products[product_handle] %}
    {% assign variant_ids = related_data[1] | split: separator %}
    {% for product_variant in related_product.variants %}
        {% assign current_id = product_variant.id | downcase %}
        {% if variant_ids contains current_id %}

            <!-- related variant // -->
            {{ product_variant.title }}
            <!-- // related variant -->

        {% endif %}
    {% endfor %}
{% endif %}
`
}

const generateRelation = ({ field, scope, schema, airfFieldKey }) => {
    let insideCode = ''
    airfFieldKey = airfFieldKey || `'${field.key}'`
    if (schema) {
        if (schema.relateTo === 'variant') {
            return generateRelationVariant({ field, scope, schema, airfFieldKey })
        }

        switch (schema.relateTo) {
            case 'product':
                insideCode = `
            {% assign related_product = all_products[handle] %}
            {% unless related_product.empty? %}
                {{ related_product.title }}
            {% endunless %}
            `
                break
            case 'collection':
                insideCode = `
            {% assign related_collection = collections[handle] %}
            {% unless related_collection.empty? %}
                {{ related_collection.title }}
            {% endunless %}
            `
                break
            case 'smart-collection':
                insideCode = `
            {% assign related_collection = collections[handle] %}
            {% unless related_collection.empty? %}
                {{ related_collection.title }}
            {% endunless %}
            `
                break
            case 'page':
                insideCode = `
            {% assign related_page = pages[handle] %}
            {% unless related_page.empty? %}
                {{ related_page.title }}
            {% endunless %}
            `
                break
            case 'blog-post':
                insideCode = `
            {% assign related_article = articles[handle] %}
            {% unless related_article.empty? %}
                {{ related_article.title }}
            {% endunless %}
            `
                break
            case 'blog':
                insideCode = `
            {% assign related_blog = blogs[handle] %}
            {% unless related_blog.empty? %}
                {{ related_blog.title }}
            {% endunless %}
            `
                break
        }
    }

    return `
{% assign ${field.key} = ${scope}.metafields.airf[${airfFieldKey}] %}
{% if ${field.key} and ${field.key} != blank %}
    {% assign separator = "###" %}
    {% assign ${field.key}_related_handles = ${field.key} | split: separator %}
    {% for handle in ${field.key}_related_handles %}
        ${insideCode}
    {% endfor %}
{% endif %}
    `  
    }

const generateSelection = ({ field, scope }) => {
    if (field.subForm.display !== 'checkboxes') {
        return generateSimple({ field, scope })
    }

    return `
{% assign ${field.key} = ${scope}.metafields.airf.${field.key} %}
{% if ${field.key} && ${field.key} != blank %}
    {% assign separator = "###" %}
    {% assign ${field.key}_selected_options = ${field.key} | split: separator %}
    {% for ${field.key}_selected_option in ${field.key}_selected_options %}
        {{ ${field.key}_selected_option }}
    {% endfor %}
{% endif %}
`  
}

const generateDate = ({ field, scope }) => {
    let dateFormat = ''
    if (field.subForm.onlyDate) {
        dateFormat ='%Y-%m-$d'
    } else if (field.subForm.format12h) {
        dateFormat ='%Y-%m-%d %I:%M %p'
    } else {
        dateFormat ='%Y-%m-%d %H:%M'
    }
    return `
{% assign ${field.key} = ${scope}.metafields.airf.${field.key} %}
{% if ${field.key} %}
    {{ ${field.key} | date: "${dateFormat}" }}
{% endif %}
`
}

const generateCoRepeater = ({ field }) => {
    let childCodes = ``
    
        for (let child of field.children) {
            let _key = child.key.replace('_[i]', '')
            
    childCodes += `
                {% if ${field.key}_child_key contains "${_key}" %}
                    <div class="${child.type}">{{ custom_object[${field.key}_child_key] }}</div>
                {% endif %}
    `
        }
    
    return `
        {% assign ${field.key} = custom_object['${field.key}'] %}
        {% if ${field.key} and ${field.key} != blank %}
            {% assign ${field.key}_childs_keys = ${field.key} | split: separator %}
            {% for ${field.key}_child_key in ${field.key}_childs_keys %}
                ${childCodes}
            {% endfor %}
        {% endif %}
`  
}

const generateCoDate = ({ field }) => {
    let dateFormat = ''
    if (field.subForm.onlyDate) {
        dateFormat ='%Y-%m-$d'
    } else if (field.subForm.format12h) {
        dateFormat ='%Y-%m-%d %I:%M %p'
    } else {
        dateFormat ='%Y-%m-%d %H:%M'
    }
    return `
        {% assign ${field.key} = custom_object['${field.key}'] %}
        {% if ${field.key} %}
            {{ ${field.key} | date: "${dateFormat}" }}
        {% endif %}
`
}

const generateCoImage = ({ field }) => {
    return `
        {% assign ${field.key} = custom_object['${field.key}'] %}
        {% if ${field.key} and ${field.key} != '&nbsp' %}
            <img src="{{ ${field.key} }}" />
        {% endif %}
`  
}

const generateCoSelection = ({ field }) => {
    if (field.subForm.display !== 'checkboxes') {
        return generateCoSimple({ field })
    }

    return `
        {% assign ${field.key} = custom_object['${field.key}'] %}
        {% if ${field.key} && ${field.key} != blank %}
            {% assign separator = "###" %}
            {% assign ${field.key}_selected_options = ${field.key} | split: separator %}
            {% for ${field.key}_selected_option in ${field.key}_selected_options %}
                {{ ${field.key}_selected_option }}
            {% endfor %}
        {% endif %}
`  
}

const generateCoBoolean = ({ field }) => {
    return `
        {% assign ${field.key} = custom_object['${field.key}'] %}
        {% if ${field.key} == "true" %}
            true
        {% else %}
            false
        {% endif %}
`  
}

const generateCoSimple = ({ field, scope }) => {
    return `
        {% assign ${field.key} = custom_object['${field.key}'] %}
        {% if ${field.key} and ${field.key} != '&nbsp' %}
            {{ ${field.key} }}
        {% endif %}
`
}

const generateJson = ({ field, scope }) => {
    return `
{% assign ${field.key} = ${scope}.metafields.airf.${field.key} %}
{% if ${field.key} and ${field.key} != blank %}
  	Value by key: {{${field.key}['YOUR_KEY']}}
  
  	Values by loop:
    {% for key_value in ${field.key} %}
       {{key_value[0]}}: {{key_value[1]}}
    {% endfor %}
{% endif %}
`
}

const extraCoTypes = {
    repeater: generateCoRepeater,
    image: generateCoImage,
    selection: generateCoSelection,
    date: generateCoDate,
    boolean: generateCoBoolean
}

const generateCustomObject = ({ field, scope, schema }) => {
    let coCodes = ``
    if (schema) {
        for (let _field of schema.fields) {
            if (!extraCoTypes[_field.type]) {
                coCodes += generateCoSimple({ field: _field })
            } else {
                coCodes += extraCoTypes[_field.type]({ field: _field })
            }
        }
    }
    return `
{% assign ${field.key} = ${scope}.metafields.airf.${field.key} %}
{% if ${field.key} and ${field.key} != blank %}
    {% assign separator = "###" %}
    {% assign ${field.key}_namespaces = ${field.key} | split: separator %}
    {% for namespace in ${field.key}_namespaces %}
        {% assign custom_object = shop.metafields[namespace] %}
        ${coCodes}
    {% endfor %}
{% endif %}
`  
}

const extraTypes = {
    repeater: generateRepeater,
    repeater_json: generateRepeaterJson,
    image: generateImage,
    selection: generateSelection,
    date: generateDate,
    boolean: generateBoolean,
    'custom-object': generateCustomObject,
    relation: generateRelation,
    json: generateJson
}


export default ({ field, scope, schema }) => {
    scope = scope.replace(/s$/, '');

    if (scope === 'variant') {
        scope = 'product.selected_variant'
    }

    // --> Simple types
    if (!extraTypes[field.type]) {
        return generateSimple({ field, scope })
    }

    if ( field.subType ) {
        return extraTypes[field.subType]({ field, scope, schema })
    }

    return extraTypes[field.type]({ field, scope, schema })
}



// WEBPACK FOOTER //
// ./src/helpers/field-liquid-generate-helper.js